import { CellHyperlinkValue, CellRichTextValue, CellValue, RichText } from "exceljs";
import Msg from "./message";
import Message from "../enum/message";

const TotalStr: string[] = Msg.getAll(Message.total);

class ExcelImportUtilsSingleton {

    public hasAnyValue(values: CellValue[]): boolean {
        for (let i = 0; i < values.length; i++) {
            if (this.hasValue(values[i])) {
                if (typeof values[i] !== 'string' || !TotalStr.includes(values[i] as string)) {
                    return true;
                }
            }
        }
        return false;
    }

    public getCellValue(value: CellValue): CellValue {
        if (value) {
            if (typeof value === 'string') {
                return value.trim();
            } else if (typeof value === 'number') {
                return value;
            } else if (value instanceof Date) {
                return value;
            } else if (typeof value === 'object') {
                const rich: CellRichTextValue = value as CellRichTextValue;
                const hyper: CellHyperlinkValue = value as CellHyperlinkValue;
                if (hyper.hyperlink && !hyper.hyperlink.includes('javascript')) {
                    return hyper.hyperlink.trim();
                } else if (rich.richText && rich.richText.length) {
                    return rich.richText.map((r: RichText) => r.text).join('').trim();
                }
            }
        }
        return '';
    }

    public hasValue(value: CellValue): boolean {
        const val: CellValue = this.getCellValue(value);
        return val !== undefined && val !== '';
    }

}

const ExcelImportUtils = new ExcelImportUtilsSingleton();

export default ExcelImportUtils;